import { plaintextValidator, numberValidator, dateValidator } from '../fields';

export const recordPaymentConstraints = {
  amount: numberValidator({ mandatory: true }),
  dateOfPayment: dateValidator({ mandatory: true })
};
